import jwt_decode from 'jwt-decode'
const getters ={
    visitedViews:state => state.tags.visitedViews,
    activeIndex:state => state.tags.activeIndex,
    getToken(state){
        if(state.user.token===""||state.user.token==null||!state.user.token){
            state.user.token = localStorage.getItem("token");
        }
        let data = jwt_decode(state.user.token);
        return JSON.parse(data.sub);
    },
    getT(state){
        if(state.user.token===""||state.user.token==null||!state.user.token){
            state.user.token = localStorage.getItem("token");
        }
        return  state.user.token;
    },
    getKeepAlive:state => state.tags.keepAlive,
    getLoginVisible(state){
        return state.user.loginVisible;
    },
    getRouterTo(state){
        return state.user.routerTo;
    },
    getUnread(state){
        return state.user.unread;
    },
    getUpload(state){
        return state.upload
    },
    getIsMobile:(state)=>{
        return state.machine.isMobile;
    },
    getMenuList:state=>{
        if(state.menu.menuList.length===0){
            state.menu.menuList = JSON.parse(localStorage.getItem("m"));
        }
        return state.menu.menuList;
    },
    getProgress:state=>{
        return state.upload.uploadProgress;
    },
    getIfOut:state=>state.user.ifOut
};

export default getters;
